import { Injectable } from '@angular/core';
import { orDefault } from 'src/app/services/value.util';

export interface TraceLogEntry {
  traceId: string;
  uiTraceParentID?: string;
  method: string;
  url: string;
  status: 'request' | 'success' | 'error';
  statusCode?: number;
  startedAt: string;
  completedAt?: string;
  requestBody?: any;
  responseBody?: any;
  errorMessage?: string;
  stack?: string;
  logType?: string;
}

@Injectable({
  providedIn: 'root'
})
export class TraceLogService {

  private requestLogs: TraceLogEntry[] = [];
  private responseLogs: TraceLogEntry[] = [];

  addRequest(entry: TraceLogEntry): void {
    this.requestLogs.push(entry);
  }

  addResponse(entry: TraceLogEntry): void {
    this.responseLogs.push(entry);
  }

  drainRequests(): TraceLogEntry[] {
    const entries = [...this.requestLogs];
    this.requestLogs = [];
    return entries;
  }

  drainResponses(): TraceLogEntry[] {
    const entries = [...this.responseLogs];
    this.responseLogs = [];
    return entries;
  }

  hasRequestLogs(): boolean { return this.requestLogs.length > 0; }
  hasResponseLogs(): boolean { return this.responseLogs.length > 0; }
  getRequestCount(): number { return this.requestLogs.length; }
  getResponseCount(): number { return this.responseLogs.length; }

  logEvent(
    method: string,
    logType: string,
    details: {
      url?: string;
      errorMessage?: string;
      stack?: string;
      status?: 'success' | 'error';
      metadata?: any;
    } = {}
  ): void {
    const traceId = this.generateHex(16);
    const now = this.getISTTime();

    this.addResponse({
      traceId,
      method,
      url: orDefault(details.url, window.location.href),
      status: details.status ?? 'error',
      startedAt: now,
      completedAt: now,
      errorMessage: details.errorMessage,
      stack: details.stack,
      requestBody: details.metadata,
      logType
    });
  }

  private getISTTime(): string {
    const now = new Date();
    const istTime = new Date(now.getTime() + (5.5 * 60 * 60 * 1000));
    return istTime.toISOString().replace('Z', '+05:30');
  }

  private generateHex(byteLength: number): string {
    const bytes = new Uint8Array(byteLength);
    crypto.getRandomValues(bytes);
    return Array.from(bytes).map(b => b.toString(16).padStart(2, '0')).join('');
  }
}